export const NewTestInfo = `flex justify-between gap-4 items-center self-start`
export const DotListClasses = 'pl-2 mt-10'
export const AddButtonClasses = 'absolute top-4 right-0'
